import { render, staticRenderFns } from "./ReciprocityVisaDuration.vue?vue&type=template&id=0b102c86&"
import script from "./ReciprocityVisaDuration.vue?vue&type=script&lang=js&"
export * from "./ReciprocityVisaDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports